import React from "react";
import { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { Overlay, Popover, Button } from "react-bootstrap";

function Sidebar() {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const target = useRef(null);

  const handleToggle = () => setShow(!show);

  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );

  const toggleFullscreen = async () => {
    if (!document.fullscreenElement) {
      try {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } catch (err) {
        console.error("Fullscreen request denied:", err);
      }
    } else {
      try {
        await document.exitFullscreen();
        setIsFullscreen(false);
      } catch (err) {
        console.error("Exit fullscreen failed:", err);
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const [sidenavopen, setSideNavOpen] = useState(true);
  const style = `
    .accordion-button {
    padding: unset !important;
    padding: .6rem .5rem;
    margin-top: .9rem;
    height: 2.7rem !important;
    max-width: unset !important;
    display: flex;
    flex-direction: row;
    border: unset;
    }


element.style {
}
.accordion-fhjhkkn {
    transition: 0.3s ease-in;
}
.ps-2 {
    padding-left: .5rem !important;
}
.pb-1 {
    padding-bottom: .25rem !important;
}
.pt-1 {
    padding-top: .25rem !important;
}
.accordion-header {
    margin-bottom: 0;
}
h2 {
    font-size: 36px;
    line-height: 50px;
}
h1, h2, h3, h4, h5, h6 {
    color: inherit;
    font-family: inherit;
    font-weight: bolder;
    margin: 0;
}
.h2, h2 {
    font-size: calc(1.325rem + .9vw);
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: .5rem;
    font-weight: 500;
    line-height: 1.2;
    color: var(--bs-heading-color);
}
*, ::after, ::before {
    box-sizing: border-box;
}
* {
    box-sizing: border-box;
}
user agent stylesheet
h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}
.accordion-item {
    color: var(--bs-accordion-color);
    background-color: var(--bs-accordion-bg);
    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion {
    --bs-accordion-color: var(--bs-body-color)
#212529
;
    --bs-accordion-bg: none !important ;
}

    .accordion-item{
      border: unset !important;
    }

    .accordion-button::after {
    flex-shrink: 0;
    width: 0.8rem;
    height: 0.8rem;
    margin-left: auto;
    margin-right: 1rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: cover;
    transition: var(--bs-accordion-btn-icon-transition);
}

  .accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
}

  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: unset;
}
  `;

  return (
    <>
      <style>{style}</style>
      <div style={{ height: "100%" }} className="row gx-0">
        <nav
          container
          className={sidenavopen ? "sidebar col-md-2" : "collapsed sidebar"}
        >
          
            <button
              onClick={() => setSideNavOpen(!sidenavopen)}
              className="expand-btn"
            >
              <i
                class="fa-regular fa-square-caret-left"
                style={{ color: "#3cc245" }}
              ></i>
            </button>
          
          <div class="sidebar-links">
            <div className="d-flex align-items-center gap-3 mb-3">
              <img
                className=""
                style={{ height: "2.5rem", marginLeft: "0.5rem" }}
                src="../Images/user5.svg"
                alt=""
                srcset=""
              />
              <h5
                className=""
                style={{ display: !sidenavopen ? "none" : "block" }}
              >
                Admin
              </h5>
            </div>

            <div class="TvZMhVkOCp"></div>
            <ul>
              <li>
                <Link
                  to="/Dashboard"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Dashboard.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Dashboard</p>
                </Link>
              </li>

              <li>
                <Link
                  to="/Clinics"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Appointment.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Clinics</p>
                </Link>
              </li>
              <li>
                <Link
                  to="/Pharmacy"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Patient.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Pharmacy</p>
                </Link>
              </li>
              <li>
                <Link
                  to="/Staff"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Patient.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Staff Management</p>
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/Subscriptions"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Prescription.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Subscription</p>
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/Reports"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Lab Result.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Analytics & Reports</p>
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="SupportTickets"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Tratment Plan.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">Support Tickets</p>
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/UserManagement"
                  className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <img
                    className="h-50"
                    src="../Images/Report & Analyltics.svg"
                    alt=""
                    srcset=""
                  />
                  <p className="div-atagcolor">User Management</p>
                </Link>
              </li>
            </ul>
          </div>
        </nav>
        <div
          style={{
            display: "flex",
            flexGrow: "1",
            padding: "unset",
            height: "100%",
          }}
          className="col-md-10"
        >
          <div className="col-12 g-0 div-colcon">
            <div className="div-TM1vTuWchY flex-jt-sb">
              <div class="sidebar-top">
                <div class="logo__wrapper">
                  <div style={{ width: "15rem", marginLeft: "2rem" }}>
                    <img
                      style={{}}
                      src="../Images/Logo.png"
                      alt="Logo"
                      class="logo-small"
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3 div-W1ShPmHBDd">
                {/* Fullscreen Button */}
                <button
                  onClick={toggleFullscreen}
                  className="btn d-flex align-items-center justify-content-center"
                  title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                  style={{ padding: "0.5rem", fontSize: "1rem" }}
                >
                  <i
                    className={`fa-solid ${
                      isFullscreen ? "fa-compress" : "fa-expand"
                    }`}
                  ></i>
                </button>

                {/* Profile Button */}
                {/* Profile Button */}
                <button
                  ref={target}
                  className="btn d-flex align-items-center justify-content-center"
                  style={{ padding: "0.5rem" }}
                  onClick={handleToggle}
                >
                  <img
                    src="../Images/Profile.svg"
                    alt="Profile"
                    style={{ height: "1rem", width: "auto" }}
                  />
                </button>

                <Overlay
                  target={target.current}
                  show={show}
                  placement="bottom-end"
                  rootClose
                  onHide={() => setShow(false)}
                >
                  {(props) => (
                    <Popover {...props} className="shadow">
                      <Popover.Body className="d-flex flex-column gap-2">
                        <Button
                          className="gradient-button"
                          variant="outline-primary"
                          size="sm"
                          onClick={() => {
                            setShow(false);
                            navigate("#");
                          }}
                        >
                          View Profile
                        </Button>
                        <Link to="/SignIn">
                          <Button
                            variant="danger"
                            className="w-100 gradient-dark-button"
                            size="sm"
                          >
                            Logout
                          </Button>
                        </Link>
                      </Popover.Body>
                    </Popover>
                  )}
                </Overlay>
              </div>

              <header id="hamburger-hd">
                <input type="checkbox" id="menyAvPaa" />
                <label id="burger" for="menyAvPaa">
                  <div></div>
                  <div></div>
                  <div></div>
                </label>
                <nav id="meny">
                  <div style={{ height: "100%", backgroundColor: "#213343" }} class="d-flex flex-column">
                    <div class="div-mV3nDcsCXh">
                      <div
                        style={{
                          width: "5rem",
                          maxWidth: "5rem",
                          height: "5rem",
                        }}
                      >
                        <img
                          src="../Images/Logo.png"
                          style={{}}
                          alt="Logo"
                          class="logo-small"
                        />
                      </div>
                      <span style={{ fontSize: "12px", color: "#888" }}>
                        Powered by PelicanRX
                      </span>
                      <span
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      ></span>
                    </div>
                    <div class="TvZMhVkOCp"></div>
                    <div class="div-XbccJyGpRY">
                      <div class="d-flex flex-column div-Yb0Usyx31B">
                        <span class="spn-HX8Z7l2ITc text-white">Admin</span>
                        <ul class="ul-WvVKfbP6Pb">
                          <li>
                            <a
                              href="/Dashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <i class="fa-solid fa-square-poll-horizontal"></i>
                              <span class="link hide">Dashboard</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/ProviderProfile.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Clinics</span>
                            </a>
                          </li>

                          <li>
                            <a
                              href="/ProviderPayments.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Modules</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/ProviderFavoriteTechnicians.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Subscription</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/ProviderClient.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Analytics & Reports</span>
                            </a>
                          </li>

                          <li>
                            <a
                              href="#dashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Settings"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Support Tickets</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="#settings"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Help"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">User Management</span>
                            </a>
                          </li>

                          <div
                            style={{ margin: ".5rem auto" }}
                            class="TvZMhVkOCp"
                          ></div>

                          <li>
                            <a
                              href="#"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Logout"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Logout Account</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </header>
            </div>
            <div id="dash-con">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
